export default __webpack_public_path__ + "static/media/edited-4.67914b00.jpg";